import { CAMPAIGNS, OTHER_WORK } from "../../lib/data";
import { CampaignCard } from "./campaigns/CampaignCard";
import { OtherWorkRow } from "./campaigns/OtherWorkRow";

export const Campaigns = () => {
  return (
    <section
      id="campaigns"
      data-testid="campaigns-section"
      className="hairline-b border-b"
    >
      <div className="max-w-[1480px] mx-auto px-5 md:px-10 pt-16 md:pt-28 pb-10 md:pb-16">
        <div className="grid grid-cols-12 gap-6">
          <div className="col-span-12 md:col-span-6">
            <div className="text-[10.5px] tracking-[0.22em] uppercase opacity-50 mb-2">
              06 — Signature Case Studies
            </div>
            <h2 className="text-3xl md:text-5xl font-bold tracking-tight leading-[0.95]">
              Work that<br />moved numbers.
            </h2>
          </div>
          <div className="col-span-12 md:col-span-5 md:col-start-8 self-end">
            <p className="text-base md:text-lg leading-relaxed text-[var(--muted)] max-w-prose">
              Five platforms that reshaped category conversations — from a
              Guinness World Record to 1.45 billion earned-media impressions to
              13.6× ROAS on Valentine&apos;s. Tap any case to read the full
              story.
            </p>
          </div>
        </div>
      </div>

      <div className="hairline-t border-t">
        {CAMPAIGNS.map((c, i) => (
          <CampaignCard
            key={c.slug}
            campaign={c}
            index={i}
            reverse={i % 2 === 1}
          />
        ))}
      </div>

      <div className="max-w-[1480px] mx-auto px-5 md:px-10 py-16 md:py-24">
        <div className="grid grid-cols-12 gap-6 mb-8 md:mb-10">
          <div className="col-span-12 md:col-span-4">
            <div className="text-[10.5px] tracking-[0.22em] uppercase opacity-50 mb-2">
              Also in the portfolio
            </div>
            <h3 className="text-2xl md:text-4xl font-bold tracking-tight leading-[0.95]">
              Other notable work.
            </h3>
          </div>
        </div>
        <ul className="hairline-t border-t">
          {OTHER_WORK.map((w, i) => (
            <OtherWorkRow key={w.title} item={w} index={i} />
          ))}
        </ul>
      </div>
    </section>
  );
};
